var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.754 27.1608L7.37466 23.1508L2.85666 22.1608L3.29766 17.5098L0.236328 14.0072L3.29766 10.5045L2.85666 5.85351L7.37466 4.86351L9.754 0.853516L14.0053 2.65851L18.2567 0.853516L20.636 4.86351L25.154 5.85351L24.713 10.5045L27.7743 14.0072L24.713 17.5098L25.154 22.1608L20.636 23.1508L18.2567 27.1608L14.0053 25.3558L9.754 27.1608ZM12.6053 18.2788L19.677 11.2072L18.272 9.76118L12.6053 15.4278L9.73866 12.6022L8.33366 14.0072L12.6053 18.2788Z",
    fill: "#1A4CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.0d94786ba241d51b46ab92c33ae180ee.svg";
export { ForwardRef as ReactComponent };